<template>
    <div>
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <div class="h3 bg-light">{{ $t('claims.existingClaims') }}</div>
                    <hr />
                    <vue-json-pretty :path="'res'"
                                     :data="dbClaims">
                    </vue-json-pretty>
                </div>
                <div class="col-sm-12 col-md-6" v-if="showCurrentUserLoadedClaims">
                    <div class="h3 bg-light">{{ $t('claims.loadedClaims') }}</div>
                    <hr />
                    <vue-json-pretty :path="'res'"
                                     :data="claims">
                    </vue-json-pretty>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import VueJsonPretty from 'vue-json-pretty'
    import claimService from '@/services/claims.service';
    import { mapGetters } from 'vuex';

    export default {
        name: 'UserClaimsDetails',
        props: {
            userId: String,
            showCurrentUserLoadedClaims: {
                type: Boolean,
                default: false
            }
        },
        components: {
            VueJsonPretty
        },
        data() {
            return {
                loading: false,
                dbClaims: {}
            };
        },
        computed: {
            ...mapGetters(['claims']),
        },
        mounted() {
            this.loadClaimsForUser();
        },
        methods: {
            loadClaimsForUser() {
                this.loading = true;

                claimService
                    .getForUser(this.userId)
                    .then(response => {
                        this.loading = false;

                        if (response.data) {
                            this.dbClaims = response.data
                        }
                    })
                    .catch(error => {
                        this.loading = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            }
        }
    }
</script>

<style scoped>
</style>
